export default "__VITE_PUBLIC_ASSET__5228c74d__"